//REACT
import React from "react";
import { Link } from "react-router-dom";
//Material-UI
import { makeStyles } from "@material-ui/core/styles";
//Componentes
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

//Estilo
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";

import { ModalSimple } from "components/Modal/confirm-modal/firma-simple/modal-simple";
import { ModalAvanzado } from "components/Modal/confirm-modal/firma-avanzada/modal-avanzado";
import { useModalAd } from "components/Modal/confirm-modal/firma-avanzada/modal-avanzado";
import { useModalSimple } from "components/Modal/confirm-modal/firma-simple/modal-simple";

const useStyles = makeStyles(headersStyle);

export default function ItemPlanes(props) {
  const classes = useStyles();
  const { showAdModal, onCloseAdModal, onShowAdModal } = useModalAd();
  const { showSignModal, onCloseSignModal, onShowSignModal } = useModalSimple();

  return (
    <React.Fragment>
      <GridItem xs={12} sm={6} md={6} lg={4}>
        <Card pricing>
          <CardBody pricing>
            <div className={classes.img}>
              <img src={props.imagen} alt="Firme Simple" />
            </div>
            <h3>{props.titulo}</h3>
            <h3 className={classes.cardTitle + " " + classes.marginTop30}>
              {props.precio}
            </h3>
            <p className={classes.cardDescription}>{props.descripcion}</p>
            {props.titulo === "Certificado Digital SII." && (
              <React.Fragment>
                <Button
                  round
                  color="primary"
                  size="sm"
                  onClick={onShowSignModal}
                >
                  {props.txtBoton01}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Link to={props.link02} state="uno">
                  <Button round color="primary" size="sm">
                    {props.txtBoton02}
                  </Button>
                </Link>
              </React.Fragment>
            )}
            {props.titulo === "Firma avanzada con Token" ? (
              <Button round color="primary" size="sm" onClick={onShowAdModal}>
                {props.txtBoton03}
              </Button>
            ) : null}
          </CardBody>
        </Card>
      </GridItem>
      <ModalSimple
        showSignModal={showSignModal}
        onCloseSignModal={onCloseSignModal}
      />
      <ModalAvanzado
        showAdModal={showAdModal}
        onCloseAdModal={onCloseAdModal}
      />
    </React.Fragment>
  );
}
